import { render, staticRenderFns } from "./FrenchWindowSizeAndGlazing.vue?vue&type=template&id=8cf08b3c&scoped=true"
import script from "./FrenchWindowSizeAndGlazing.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowSizeAndGlazing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf08b3c",
  null
  
)

export default component.exports